import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {clearGeoJsonLayers, createGeoJsonLayer, toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {getMutationFeatureInfo, getMutationGeometryColumnByFeatureInfo} from "@/helpers/tools/tools-mutation-helper";
import {
    generateDataTableItem,
    generateDataTableMutationAttributes
} from "@/components/layer/info/info/layer-info-info-item-component";
import {initDataTableStandAloneEditor} from "@/helpers/datatable/datatable-standalone-editor-helper";
import {LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon} from "ol/geom";
import {showNotification} from "@/helpers/notification-helper";
import {getTemporaryLayerByIndex} from "@/helpers/layer/temporary/temporary-layer-helper.js";

let toolsMutationSelectLayerFeatures = []

export function getToolsMutationSelectLayer() {
    return getBySelector('#slcMutationSelectLayer')
}

export function getToolsMutationSelectLayerValue() {
    const element = getBySelector('#slcMutationSelectLayer')
    if(element) {
        return element.value
    }
    return undefined
}

export function clearToolsMutationSelectLayer() {
    const element = getBySelector('#slcMutationSelectLayer')
    if(element) {
        getBySelector('#slcMutationSelectLayer').value = ''
    }
}

export function updateToolsMutationSelectLayer(element) {
    if(element && element.value) {
        showElementsBySelector('#divMutationSelectLayer')
    } else {
        getBySelector('#divMutationSelectLayerItems').innerHTML = ''
        hideElementsBySelector('#divMutationSelectLayer')
    }
}

export function createToolsMutationSelectLayer() {

    const featureInfo = getMutationFeatureInfo()
    const geometryColumn = getMutationGeometryColumnByFeatureInfo(featureInfo)

    let geometry = ''
    const geometries = []
    switch (geometryColumn.AttributeTypeID) {
        case 24: // Punt geom
            toolsMutationSelectLayerFeatures.map(feature => {
                geometry = new Point(feature.geometry.coordinates)
            })
            break;
        case 240: // Punt multi geom
            toolsMutationSelectLayerFeatures.map(feature => {
                geometries.push(new Point(feature.geometry.coordinates))
            })
            geometry = new MultiPoint(geometries)
            break;
        case 25: // Lijn geom
            toolsMutationSelectLayerFeatures.map(feature => {
                geometry = new LineString(feature.geometry.coordinates)
            })
            break;
        case 250: // Lijn multi geom
            toolsMutationSelectLayerFeatures.map(feature => {
                geometries.push(new LineString(feature.geometry.coordinates))
            })
            geometry = new MultiLineString(geometries)
            break;
        case 26: // Vlak geom
            toolsMutationSelectLayerFeatures.map(feature => {
                geometry = new Polygon(feature.geometry.coordinates)
            })
            break;
        case 260: // Vlak multi geom
            toolsMutationSelectLayerFeatures.map(feature => {
                geometries.push(new Polygon(feature.geometry.coordinates))
            })

            geometry = new MultiPolygon(geometries)
            break;
        }


    window.mutation_geom = geometry
    window.mutation_geom_column = geometryColumn.Attribute

    toolsMutationSelectLayerFeatures = []

    let dataTableItem = generateDataTableItem(featureInfo, 0, 0, 0, featureInfo.BookmarkPresentationID)
    dataTableItem = generateDataTableMutationAttributes(dataTableItem, featureInfo)
    initDataTableStandAloneEditor(dataTableItem, 'create')
}

export function getGeometryMutationType() {
    const featureInfo = getMutationFeatureInfo()
    const geometryColumn = getMutationGeometryColumnByFeatureInfo(featureInfo)

    let geometryType = {}
    switch (geometryColumn.AttributeTypeID) {
        case 24: // Punt geom
        case 240: // Punt multi geom
            geometryType.type = 'Point'
            geometryType.name = 'punt'
            break;
        case 25: // Lijn geom
        case 250: // Lijn multi geom
            geometryType.type = 'LineString'
            geometryType.name = 'lijn'
            break;
        case 260: // Vlak multi geom
        case 26: // Vlak geom
            geometryType.type = 'Polygon'
            geometryType.name = 'vlak'
            break;
    }

    return geometryType
}

export function addToolsMutationSelectLayerFeature(feature) {
    toolsMutationSelectLayerFeatures.push(feature)
}

export function addToolsMutationSelectLayerItem(items) {
    const bookmarkPresentationID = getToolsMutationSelectLayerValue()
    let name = ''
    if(bookmarkPresentationID) {

        if(bookmarkPresentationID.includes('temporary-')) {
            name = getTemporaryLayerByIndex(bookmarkPresentationID).Name
        }

        const featureInfo = getMutationFeatureInfo()
        const geometryColumn = getMutationGeometryColumnByFeatureInfo(featureInfo)
        if([24,25,26].includes(geometryColumn.AttributeTypeID)) {
            clearToolsMutationSelectLayerItem(false)
        }

        const mainTab = items.mainTabs.find(mainTab => mainTab.BookmarkPresentationID === parseInt(bookmarkPresentationID) || mainTab.Name === name)


        console.log(items)
        console.log(mainTab)

        if(mainTab && mainTab.features.length > 0) {
            const feature = mainTab.features[0].feature
            // console.log(feature)

            const geometryMutationType = getGeometryMutationType()
            if(feature.geometry.type !== geometryMutationType.type) {
                showNotification('Dit object kan niet geselecteerd worden omdat dit geen ' + geometryMutationType.name  + ' is', '', 'warning')
                return
            }

            let featureId = feature.id

            createGeoJsonLayer(feature, 'mutation-select-layer-item-' + feature.id, true)
            addToolsMutationSelectLayerFeature(feature)


            getBySelector('#divMutationSelectLayerItems').innerHTML +=
            `<div class="card card-hover-secondary mt-2">    
                <div class="card-header bg-lighter p-1">
                    ${featureId}
                    <button data-id="${featureId}" title="Verwijder uit active lagen" class="btn btn-sm borderless icon-btn float-right btnRemoveToolsMutationSelectLayerItem">
                        <span class="fa fa-times" data-id="${featureId}"></span>
                    </button>
                </div>
            </div>`

            getBySelector('#btnMutationSelectLayer').disabled = false
        }
    }
}

export function removeToolsMutationSelectLayerItem(id) {
    if(id) {
        toggleGeoJsonLayer( 'mutation-select-layer-item-' + id, '', false)
        toolsMutationSelectLayerFeatures = toolsMutationSelectLayerFeatures.filter(item => item.id !== id)
        getBySelector('#btnMutationSelectLayer').disabled = true
    }
}

export function clearToolsMutationSelectLayerItem(clearSelect = true) {
    const slcMutationSelectLayer = getBySelector('#slcMutationSelectLayer')
    if(slcMutationSelectLayer) {
        if(clearSelect) {
            getBySelector('#slcMutationSelectLayer').value = ''
            hideElementsBySelector('#divMutationSelectLayer')
        }
        clearGeoJsonLayers()
        getBySelector('#divMutationSelectLayerItems').innerHTML = ''
    }
}
